import { DocumentEdit } from './Edit'
import { DocumentsList } from './List'

export const documents = {
  name: 'documents',
  list: DocumentsList,
  edit: DocumentEdit,
}
